import fetchApi from "../fetchApi";
export const resendUserInvite = async (id) => {

    const options = {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        body: JSON.stringify({
            "id": id
        }),
        redirect: 'follow'
    }

    return await fetchApi(`users/resend-invite`, options);
};